<template>
  <div class="flex flex-1 flex-col" :class="variant === 'sheet' && 'p-4'">
    <div
      v-if="checker.upload.value.kind === 'analyzing'"
      class="flex flex-1 flex-col items-center justify-center"
    >
      <Spinner :size="32" />
      <p class="mt-5 text-[20px] leading-[25px] font-medium text-gray-800">
        Analyzing for matches
      </p>
    </div>

    <div
      v-else-if="checker.upload.value.kind === 'uploading'"
      class="flex flex-1 flex-col items-center justify-center rounded-[20px] border-2 border-gray-200 px-6"
    >
      <UploadProgressRing :percentage="checker.upload.value.percentage" />
      <div
        v-truncate
        class="mt-3.5 w-full text-center text-[14px] leading-[18px] text-gray-800"
      >
        <div data-truncate-target>
          Uploading {{ checker.upload.value.name }}
        </div>
      </div>
    </div>

    <label
      v-else
      class="flex flex-1 cursor-pointer flex-col items-center justify-center rounded-[20px] border-2 border-dashed border-red-200 px-6 transition-colors"
      :class="dragging ? 'bg-red-200/20' : 'bg-red-200/5 hover:bg-red-200/10'"
      @dragover.prevent="dragging = true"
      @dragleave.prevent="dragging = false"
      @drop.prevent="handleDrop"
    >
      <input type="file" class="hidden" @change="handleInput" />
      <FileTextIcon class="size-6 text-red-500" aria-hidden="true" />
      <p
        v-if="variant === 'modal'"
        class="mt-[18px] text-center text-[14px] leading-5 text-gray-800"
      >
        Drag and drop infringing file
        <br />
        or
        <span class="font-medium text-red-500">upload from computer</span>
      </p>
      <p
        v-else
        class="mt-[18px] text-[14px] leading-5 font-medium text-red-500"
      >
        Upload from device
      </p>
      <p class="mt-[18px] text-[14px] leading-[18px] text-gray-400">Max 2GB</p>
    </label>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { FileTextIcon } from '@dacr/icons'

import Spinner from '@/shared/components/Spinner.vue'
import UploadProgressRing from '../CreateReport/UploadProgressRing.vue'
import { useChecker } from './useChecker'

defineProps<{ variant: 'modal' | 'sheet' }>()

const checker = useChecker()
const dragging = ref(false)

const handleDrop = (event: DragEvent) => {
  dragging.value = false
  const file = event.dataTransfer?.files[0]
  if (file) void checker.pickFile(file)
}

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]
  target.value = ''
  if (file) void checker.pickFile(file)
}
</script>
